import toastr from 'toastr';

// possible values for type: "warning", success", "info" or "error"

/**
 * Bug 1422: Always auto hide errors
 * Commit [8f7c8fb]: Always hide non-errors
 * Therefore: Always auto hide all Toastr Notifications
 * 
 * Set autoHide default value to true, allowing it to be overridden on a
 * case by case basis if a value of false is provided
 */
function Notification(type, title, msg, autoHide = true, positionClass = "toast-top-right", onclickEvent = null, showDuration = '300', hideDuration = '3000', closeButton = false) {
   
    toastr.clear();

    toastr.options = {
        "closeButton": closeButton,
        "debug": false,
        "newestOnTop": true,
        "progressBar": (autoHide) ? true : false,
        "positionClass": positionClass,
        "preventDuplicates": true,
        "onclick": onclickEvent,
        "showDuration": (autoHide) ? showDuration : "0",
        "hideDuration": (autoHide) ? hideDuration : "0",
        "timeOut": (autoHide) ? hideDuration : "0",
        "extendedTimeOut": (autoHide) ? "1000" : "0",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "slideDown",
        "hideMethod": "fadeOut",
        "closeMethod": "fadeOut",
        "tapToDismiss": true
    };

    toastr[type](msg, title);
}

export default Notification;
